import React, { useContext } from 'react'
import { MainContext } from '../../context/Main.context'
import { LicenceTypes } from '../../utils/LicenceTypes';
import { ErrorMessage } from '../ErrorMessage/ErrorMessage';
import { Tab } from '../Tab/Tab'
import { InputField, InputFieldLabel, InputFieldWrapper } from '../Tab/Tab.styled';

export const ContactTab = () => {
    const {
        currentFormTab,
        register,
        licenceType,
        errors,
    } = useContext(MainContext); 

    return (
        <Tab show={currentFormTab === 2}>
            <h2>Contact du licencié :</h2>
            <InputFieldWrapper>
                <InputFieldLabel htmlFor="email">Email :</InputFieldLabel>
                <InputField 
                    type="email"
                    id="email"
                    name="email"
                    placeholder={
                        licenceType !== LicenceTypes.YOUNG ? "Email du licencié" : "Email du licencié (si possible)"
                    }
                    {...register("email", {
                        required: {
                            value: licenceType !== LicenceTypes.YOUNG,
                            message: "Veuillez entrer le mail du licencié"
                        }
                    })}
                />
                <ErrorMessage message={errors.email && errors.email.message} />
            </InputFieldWrapper>
            <InputFieldWrapper>
                <InputFieldLabel htmlFor="phone">Téléphone :</InputFieldLabel>
                <InputField
                    type="text"
                    id="phone"
                    name="phone"
                    placeholder={
                        licenceType !== LicenceTypes.YOUNG ? "Téléphone" : "Téléphone du licencié (si possible)"
                    }
                    {...register("phone", {
                        required: {
                            value: licenceType !== LicenceTypes.YOUNG,
                            message: "Veuillez entrer le téléphone du licencié"
                        },
                        pattern: {
                            value: /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/,
                            message: "Veuillez entrer un numéro de téléphone valide"
                        }
                    })}
                />
                <ErrorMessage message={errors.phone && errors.phone.message} />
            </InputFieldWrapper>
        </Tab>
    )
}
